<template>
  <div class="flex items-start">
    <div class="flex flex-col items-center">
      <Avatar
        :size="80"
        :url="previewFile(org.currentOrganization?.logo)"
        :name="org.currentOrganization?.organizationName"
      />
      <a-button @click="selectAvatar" type="text" class="mt-4 mx-auto text-center">编辑</a-button>
    </div>
    <div class="flex-1 pl-[32px]">
      <div style="color: rgba(0, 0, 0, 0.5); margin-bottom: 16px">
        {{ org.currentOrganization.organizationName }}
        ·
        <template v-if="orgSeat">
          <template v-if="orgSeat.organizationAccountSeatType === OrgAccountSeatType.Preempt">
            <span
              v-if="
                orgSeat.schematicDiagramDesignSeatQuantity !==
                orgSeat.schematicDiagramDesignSeatAssignedQuantity
              "
            >
              授权在线席位：{{ orgSeat.schematicDiagramDesignSeatQuantity }}位，当前在线席位：{{
                orgSeat.onlineSchematicDiagramDesignSeatQuantity ?? 0
              }}
              位
            </span>
            <span v-else>
              设计席位分配已达上限（总授权
              {{ orgSeat.schematicDiagramDesignSeatQuantity }}
              位，已全部分配）。如需新增成员，请您先撤销部分已分配的席位，或联系客服申请增加授权。
            </span>
          </template>
          <template v-else>
            <span
              v-if="
                orgSeat.schematicDiagramDesignSeatQuantity !==
                orgSeat.schematicDiagramDesignSeatAssignedQuantity
              "
            >
              总授权席位：{{ orgSeat.schematicDiagramDesignSeatQuantity }} 位，已分配：{{
                orgSeat.designSeatAssignedQuantity ?? 0
              }}
              位，剩余：{{
                orgSeat.schematicDiagramDesignSeatQuantity -
                (orgSeat.designSeatAssignedQuantity ?? 0)
              }}
              位
            </span>
            <span v-else>
              设计席位分配已达上限（总授权
              {{ orgSeat.schematicDiagramDesignSeatQuantity }}
              位，已全部分配）。如需新增成员，请您先撤销部分已分配的席位，或联系客服申请增加授权。
            </span>
          </template>
        </template>
      </div>
      <template v-for="(m, i) in dataState.rows" :key="m.employeeId">
        <SeatSettingRow
          :member="m"
          @set-seat="p => handleSetSeat(m, p)"
          @refresh="queryRequest()"
        ></SeatSettingRow>
      </template>
    </div>
  </div>
  <InviteModal
    :visible="inviteVisible"
    @close="handleInviteVisible(false)"
    :inviteToken="inviteToken"
  />
  <PermissionManager
    v-model:visible="selectorVisible"
    title="调整项目权限"
    :isMember="true"
  ></PermissionManager>
</template>
<script setup lang="ts">
import { reactive, ref, onMounted } from 'vue'
import { Avatar } from '@elecmap/elecmap-ui'
import { generateInvitedToken, updateOrganizationLogo } from '@elecmap/api/src/ram'
import { getCurrentSeat, listEmployeeSeat, updateEmployeeSeat } from '@elecmap/api/src/ram/seat'
import {
  OrgAccountSeatType,
  type EmployeeSeat,
  type OrgSeat,
  type SeatType,
} from '@elecmap/api/src/ram/seat.d'
import InviteModal from '@elecmap/shared/src/components/InviteModal.vue'
import PermissionManager from '../member-manage/permission-adjust.vue'
import { useOrganization } from '@/store/organization'
import { previewFile } from '@elecmap/api/src/cad/file'
import { selectFile } from '@elecmap/shared/src/utils/dom'
import SeatSettingRow from '@/components/SeatSetting/seat-setting-row.vue'
import { notificationWarn } from '@elecmap/shared/src/utils/notification'

const inviteVisible = ref(false)
const inviteToken = ref()
const org = useOrganization()

const selectorVisible = ref(false)

const dataState = reactive<{ rows: EmployeeSeat[] }>({ rows: [] })
const orgSeat = ref<OrgSeat>()

const paginationState = reactive({
  pageIndex: 1,
  pageSize: 100,
  totalCount: 0,
})

const handleInviteVisible = (visible: boolean) => {
  inviteVisible.value = visible
  if (visible) {
    generateInvitedToken().then((res: any) => {
      inviteToken.value = res
    })
  }
}

const queryRequest = () => {
  listEmployeeSeat().then(data => {
    dataState.rows = data.data || []
    paginationState.totalCount = data.totalCount
  })
  getCurrentSeat().then(data => {
    orgSeat.value = data
  })
}

async function selectAvatar() {
  const f = await selectFile()
  await updateOrganizationLogo({ logo: f[0].uuid })
  org.currentOrganization.logo = f[0].uuid
}

function handleSetSeat(m: EmployeeSeat, seatType: SeatType) {
  updateEmployeeSeat({
    employeeId: m.employeeId,
    seatType,
  }).then(() => {
    queryRequest()
  }).catch(e => {
    const num = orgSeat.value.schematicDiagramDesignSeatQuantity
    notificationWarn(`已授权设计席位${num}位，已分配${num}位，席位已满 ，无法再分配给新成员。如需调整，请先释放已有席位或联系管理员扩容。`)
  })
}
onMounted(() => {
  queryRequest()
})
</script>

<style lang="less">
.em-page {
  margin-top: 4px;

  .em-page-header {
    height: 26px;
  }
}

.manage-page {
  padding-right: 16px;
}
</style>
